<dx-form *ngIf="!validationV2"
         id="form"
         [formData]="emptyFormData"
         [colCount]="1"
         [showColonAfterLabel]="true"
         [labelMode]="labelModeNew"
         [labelLocation]="labelLocation"
         [readOnly]="readOnly"
         (onFieldDataChanged)="onFormChange($event)"
>
  <dxi-item >
    <div *dxTemplate>

      <dx-select-box #selectBox
      [dataSource]="dataSource || []"
      [valueExpr]="valueExpr"
      displayExpr="aciklama"
      [value]="selectedValue | lookupValueTypePipe : type"
      [placeholder]="placeholder"
      (onValueChanged)="onValueChange($event)"
      [disabled]="disabled"
      [readOnly]="readOnly"
      [searchEnabled]="true"
      [label]="labelMode === 'outside'?'':label"
      [labelMode]="labelModeNew"
      class="{{readOnly?'md:w-[15rem] rounded-full read-only-area':'md:w-[15rem] rounded-full'}}"
      validationMessagePosition="bottom"
      [showClearButton]="showClearBtn"
      (onKeyDown)="handleKeyDown($event)"
      (onOpened)="onOpened()"
      [tabIndex]="tabIndex"
      >
      <dx-validator>
        <dxi-validation-rule
        *ngFor="let rule of( validationRul || [])"
        [type]="rule?.type"
        [message]="rule?.message">
      </dxi-validation-rule>
    </dx-validator>
  </dx-select-box>
  
</div>
  </dxi-item>
</dx-form>

<dx-select-box *ngIf="validationV2"
               [dataSource]="dataSource"
               [valueExpr]="valueExpr"
               displayExpr="aciklama"
               [value]="selectedValue"
               [placeholder]="placeholder"
               (onValueChanged)="onValueChange($event)"
               [disabled]="disabled"
               [readOnly]="readOnly"
               [searchEnabled]="true"
               [label]="labelMode === 'outside' ? '' : label"
               [labelMode]="labelModeNew"
               class="md:w-[15rem] rounded-full"
               validationMessagePosition="bottom"
               [showClearButton]="showClearBtn"
               (onOpened)="onOpened()"
>
  <dx-validator>
    <dxi-validation-rule
      *ngFor="let rule of validationRules"
      [type]="rule?.type"
      [message]="rule?.message"
      [min]="rule?.min"
      [max]="rule?.max"
    >
    </dxi-validation-rule>
  </dx-validator>
</dx-select-box>
